export function scrollToContent(options) {
    document.querySelector('main').scrollIntoView(options)
}
